import { FlatTreeControl } from '@angular/cdk/tree';
import { Component } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { ActivatedRoute } from '@angular/router';
import { AccountContact } from 'common';
import { ApplicationPermissions, Group, Permission } from '../../../models/application-permissions.model';

interface PermissionData {
  name: string;
  children?: PermissionNode[];
}

interface PermissionNode {
  expandable: boolean;
  name: string;
  level: number;
}

@Component({
  selector: 'acc-permissions',
  templateUrl: './permissions.component.html',
  styleUrls: ['./permissions.component.scss'],
})
export class PermissionsComponent {
  private _transformer = (node: PermissionData, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level,
    };
  };

  treeControl = new FlatTreeControl<PermissionNode>(
    (node) => node.level,
    (node) => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.children
  );

  dataSource: {
    dataSource: MatTreeFlatDataSource<
      PermissionData,
      {
        expandable: boolean;
        name: string;
        level: number;
      },
      {
        expandable: boolean;
        name: string;
        level: number;
      }
    >;
    name: string;
  }[] = [];

  constructor(private activatedRoute: ActivatedRoute) {
    const treeData = this.buildTreeData();
    for (let i = 0; i < treeData.length; i++) {
      let dataSrc = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
      dataSrc.data = treeData[i]?.children;
      this.dataSource.push({ dataSource: dataSrc, name: treeData[i].name });
    }
  }

  private buildTreeData(): PermissionData[] {
    const allPermissions = <ApplicationPermissions>this.activatedRoute.snapshot.data.permissions;

    const onlineAccessGroup: Group = { groupId: 0, groupName: 'Online Status', permissions: [], allSelected: false, indeterminate: false };
    onlineAccessGroup.permissions.push({ permissionName: 'Has Access', permissionValue: 0, selected: false, invalid: false });
    allPermissions.groups.splice(0, 0, onlineAccessGroup);

    const contacts = <AccountContact[]>this.activatedRoute.snapshot.data.contacts;
    return allPermissions.groups.map((g) => {
      return {
        name: g.groupName,
        children: this.buildUserlistPerPermission(g.permissions, contacts),
      };
    });
  }

  private buildUserlistPerPermission(permissions: Permission[], contacts: AccountContact[]): any {
    return permissions.map((p) => {
      return {
        name: p.permissionName,
        children: contacts
          .filter((c) => c.accountPermissions > 0 && (c.accountPermissions & p.permissionValue) === p.permissionValue)
          .map((fc) => {
            return { name: `${fc.firstName} ${fc.lastName} (${fc.email})` };
          }),
      };
    });
  }

  hasChild = (_: number, node: PermissionNode) => node.expandable;
}
